import React from "react";
import { motion } from "framer-motion";
import { BookOpenIcon } from "lucide-react";
import { TransformButton } from "./TransformButton";
const TOMOS = [{
  n: "TOMO I",
  title: "Diagnostica con Seguridad Antes de Tocar un Diente",
  desc: "Aprende a evaluar cualquier caso complejo con un protocolo que te ayuda a identificar riesgos, tomar mejores decisiones y saber exactamente cuándo aceptar un tratamiento."
}, {
  n: "TOMO II",
  title: "Nunca Más Dudes al Definir la Dimensión Vertical",
  desc: "Descubre un método paso a paso para determinar cuándo modificar la DVO y planificar rehabilitaciones con mayor seguridad y previsibilidad."
}, {
  n: "TOMO III",
  title: "Diseña Rehabilitaciones que se Vean Bien… y Duren Años",
  desc: "Integra estética y función con un sistema que te ayudará a reducir fracturas, mejorar la estabilidad y aumentar la satisfacción del paciente."
}, {
  n: "TOMO IV",
  title: "El Orden Correcto para Rehabilitar Sin Retrabajos",
  desc: "Conoce la secuencia clínica que te permitirá organizar tratamientos complejos, minimizar errores y reducir ajustes innecesarios."
}, {
  n: "TOMO V",
  title: "Cómo Resolver Complicaciones Antes de que se Conviertan en un Problema",
  desc: "Aprende protocolos claros para prevenir y manejar fracturas, sensibilidad, molestias oclusales y otras complicaciones frecuentes."
}, {
  n: "TOMO VI",
  title: "Convierte un Buen Diagnóstico en Tratamientos de Alto Valor",
  desc: "Descubre cómo presentar casos complejos con autoridad para que tus pacientes comprendan el valor del tratamiento y acepten con mayor confianza."
}];
const EXTRAS = [{
  emoji: "📝",
  text: "Más de 30 protocolos clínicos listos para aplicar en cada etapa del tratamiento."
}, {
  emoji: "📋",
  text: "Checklists profesionales para reducir errores y estandarizar tu proceso de trabajo."
}, {
  emoji: "🦷",
  text: "Algoritmos de decisión clínica que eliminan la improvisación frente a casos complejos."
}, {
  emoji: "📊",
  text: "Matrices de evaluación y filtros de riesgo para analizar cada caso antes de presupuestar."
}, {
  emoji: "📸",
  text: "Guías visuales y herramientas de planificación para documentar y ejecutar con previsibilidad."
}];
export function Tomos() {
  return <section className="w-full bg-[var(--cream)] px-4 py-14" data-id="element-252" data-mp="24yl006bez905">
      <div className="mx-auto max-w-3xl" data-id="element-253" data-mp="2iym4dvqw0ykd">
        <div className="text-center" data-id="element-254" data-mp="2ixkhmu0ienmt">
          <h2 className="font-serif-display text-2xl font-extrabold text-gray-900 sm:text-3xl" data-id="element-255" data-mp="2iwj2oegdhgzt">
            📦 ¿Qué encontrarás dentro de Protocolo Clínica Segura™?
          </h2>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-256" data-mp="2sqjfz3lt5sjm">
          {TOMOS.map((t, i) => <motion.div key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 2 * 0.08
        }} className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm" data-id="element-257" data-mp="2nq430d5fun26" data-mpi={i}>
              <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-[var(--brand)] px-3 py-1 text-xs font-bold text-white" data-id="element-258" data-mp="3lan80j1m0tm7">
                <BookOpenIcon className="h-3.5 w-3.5" data-id="element-259" data-mp="37acf7agqp4ye" /> {t.n}
              </div>
              <h3 className="mb-2 text-base font-bold leading-snug text-gray-900" data-id="element-260" data-mp="3c9fnd3s0nral">{t.title}</h3>
              <p className="text-sm leading-relaxed text-gray-600" data-id="element-261" data-mp="2xl2nhvpt5oat">{t.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-[var(--brand)]/15 bg-white p-6" data-id="element-262" data-mp="32dm0orkl2hf3">
          <h3 className="mb-4 text-center text-base font-bold text-[var(--brand)] sm:text-lg" data-id="element-263" data-mp="2olxpcqi5rwz6">
            📲 Además, recibirás acceso inmediato a:
          </h3>
          <ul className="space-y-3" data-id="element-264" data-mp="2emqec9ywcef8">
            {EXTRAS.map(e => <li key={e.text} className="flex items-start gap-3 text-sm text-gray-700" data-id="element-265" data-mp="2eojj1jpy8okl">
                <span className="text-xl leading-none" data-id="element-266" data-mp="2jnntsesiuud1">{e.emoji}</span>
                {e.text}
              </li>)}
          </ul>
          <p className="mt-5 text-center text-sm font-medium text-gray-500" data-id="element-267" data-mp="3hwug50ed9cp5">
            Cualquier rehabilitación compleja que llegue a tu consultorio… tendrás un sistema
            claro para <strong data-id="element-268" data-mp="387kmhg3vjlyx">evaluarla, planificarla y ejecutarla con mayor seguridad.</strong>
          </p>
        </div>

        <TransformButton label="Quiero acceso a todo el sistema" data-id="element-269" data-mp="338zl3dcvyw8w" />
      </div>
    </section>;
}